import React, { Component } from "react";
import styles from "./winterMaintenceMapWrapper.module.scss";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { regionsService } from "./JsonContents/Regions/RegionService";

class WinterMaintenceRegionsTools extends Component {
  onRegionsChangeHandler(id) {
    const { winterArea, winterAreasFilter, onSetWinterAreasFilter, onSetGeozoneSearch } = this.props;

    const region = regionsService.filter((x) => {
      return x[id] !== undefined;
    })[0];

    const winterAreaRegion = winterArea.regions.filter((x) => {
      return x.id === id;
    })[0];

    if (region !== undefined) {
      const geometry = JSON.stringify(region[id].features[0].geometry);

      onSetGeozoneSearch(geometry, winterAreaRegion.title);
    } else {
      onSetGeozoneSearch(null);
    }

    const filter = winterAreasFilter.map((x) => {
      if (x.winterAreaId === winterArea.id) {
        x.regionId = id;
      }

      return x;
    });

    onSetWinterAreasFilter(filter);
  }

  render() {
    const { winterArea } = this.props;

    return (
      <div className={styles.regionsFilterContainer}>
        <div>Районы:</div>

        <Select
          style={{ width: "340px", height: "24px", margin: "0px", fontSize: "12px" }}
          onChange={(e) => {
            this.onRegionsChangeHandler(e.target.value);
          }}
          placeholder={"Район"}
        >
          <MenuItem value={null} className={styles.MuiButtonBase_resolve}>
            Все
          </MenuItem>

          {winterArea.regions.map((x) => {
            return (
              <MenuItem key={x.id} value={x.id} name={x.title} className={styles.MuiButtonBase_resolve}>
                {x.title}
              </MenuItem>
            );
          })}
        </Select>
      </div>
    );
  }
}

export default withWinterMaintence(React.memo(WinterMaintenceRegionsTools));
